import Home from "../screens/Home";
import Simulacao from "../screens/Simulacao";

const sandbox = "";
export const routes = [
  {
    path: `${sandbox}/planejar//`,
    component: Home,
    name: "Home",
    menu: false,
  },
  {
    path: `${sandbox}/planejar/simulacao/:select`,
    component: Simulacao,
    name: "Simulacao",
    menu: false,
  },
  {
    path: '*',
    component: Home,
  }
];
